import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';

export function Empty() {
  const { blocks = [], editMode, widgetWidth } = useSettings();

  if (blocks.length || !editMode) {
    return null;
  }

  return (
    <EmptyMessageBlock _width={widgetWidth}>
      There are no blocks yet. Add the first block to start building your Popup.
    </EmptyMessageBlock>
  );
}

const EmptyMessageBlock = styled.div<{ _width?: number }>`
  max-width: 100%;
  margin: 0 auto;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  width: ${({ _width }) => (_width ? `${_width}px` : 'auto')};
`;
